import {
  FETCH_DASHBOARD_REQUEST,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE,
  FETCH_DASHBOARD_OVERVIEW_REQUEST,
  FETCH_DASHBOARD_OVERVIEW_SUCCESS,
  FETCH_DASHBOARD_OVERVIEW_FAILURE,
  FETCH_PAPER_ATTENDANCE_REQUEST,
  FETCH_PAPER_ATTENDANCE_SUCCESS,
  FETCH_PAPER_ATTENDANCE_FAILURE,
  FETCH_STUDENT_OVERVIEW_REQUEST,
  FETCH_STUDENT_OVERVIEW_SUCCESS,
  FETCH_STUDENT_OVERVIEW_FAILURE,
} from "../actions/dashboardActions";

const initialState = {
  totals: {},                // /dashboard totals
  overview: {},              // /dashboardOverview totals + weeklyTrend
  paperAttendance: [],       // /paper-attendance
  studentOverview: {         // /student-attendance-overview with pagination
    data: [],
    pagination: {},
  },
  loading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // ------------------ REQUEST ------------------
    case FETCH_DASHBOARD_REQUEST:
    case FETCH_DASHBOARD_OVERVIEW_REQUEST:
    case FETCH_PAPER_ATTENDANCE_REQUEST:
    case FETCH_STUDENT_OVERVIEW_REQUEST:
      return { ...state, loading: true, error: null };

    // ------------------ SUCCESS ------------------
    case FETCH_DASHBOARD_SUCCESS:
      return { ...state, loading: false, totals: action.payload };

    case FETCH_DASHBOARD_OVERVIEW_SUCCESS:
      return { ...state, loading: false, overview: action.payload };

    case FETCH_PAPER_ATTENDANCE_SUCCESS:
      return { ...state, loading: false, paperAttendance: action.payload };

    case FETCH_STUDENT_OVERVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        studentOverview: {
          data: action.payload.data,
          pagination: action.payload.meta.pagination || {},
        },
      };

    // ------------------ FAILURE ------------------
    case FETCH_DASHBOARD_FAILURE:
    case FETCH_DASHBOARD_OVERVIEW_FAILURE:
    case FETCH_PAPER_ATTENDANCE_FAILURE:
    case FETCH_STUDENT_OVERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default dashboardReducer;